import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useEffect, useState} from 'react';
import {
  Dimensions,
  Image,
  ImageStyle,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import {connect} from 'react-redux';
import {checkSignedUser, info} from '../../../data/constants/info';
import {ConnexionTitle} from '../../../data/constants/titles';
import {StackParams} from '../../../data/types/navigation';
import {ImageServices} from '../../../services/applicatif/image';
import mapDispatchToProps from '../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../services/redux/mapStateToProps';
import {globalStyle, reloadStyles} from '../../styles/globalStyle';
import ConfirmationModal from '../Modal/ConfirmationModal/index.web';
import {MenuItemType} from './types/MenuItem';

const styleGradient: React.CSSProperties = {
  background: 'linear-gradient(to right, #1D5B42, #58A618)',
  borderRadius: 16,
  height: 156,
  paddingLeft: 14,
  paddingRight: 14,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  flex: 1,
  boxShadow: '1px 0px 50px rgba(88, 166, 25, 0.3)',
};

type NavigationProps = StackNavigationProp<StackParams, 'Glossaire'>;

interface MenuItemProps {
  data: MenuItemType[];
  isHome: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  user?: any;
  numberNotification?: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  disconnectedUser?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  signOutUser: any;
}

export function FMenuItem(props: MenuItemProps) {
  const {navigate} = useNavigation<NavigationProps>();
  const {
    data,
    isHome = true,
    user,
    signOutUser,
    numberNotification,
    disconnectedUser,
  } = props;
  const userConnected = React.useRef(false);
  const datas: MenuItemType[] = data;
  const [screenFocus, setScreenFocus] = useState('');
  const [tokenDto, setTokenDto] = useState({deviceToken: ''});
  const [profilePicture, setProfilePicture] = useState<string>('');

  const handleLogin = () => {
    if (userConnected.current) {
      setTokenDto({
        deviceToken:
          user && user.data && user.data.deviceToken
            ? user.data.deviceToken
            : '',
      });
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      disconnectedUser(tokenDto, () => {});
      signOutUser({}, () => {
        navigate('Home');
      });
    } else {
      navigate('Inscription');
    }
  };
  const [itemState] = React.useState(datas);

  const save = () => {
    cancel();
    navigate('Login', {data: screenFocus});
  };
  const cancel = () => {
    setShowModal(false);
  };
  let infos = {...info};
  if (checkSignedUser(user).connected) {
    infos = checkSignedUser(user).data;
    userConnected.current = true;
  } else {
    infos = {...info};
    userConnected.current = false;
  }
  const [stylesState, setStyle] = useState(globalStyle);
  const [ShowModal, setShowModal] = useState(false);
  const updateStyles = () => {
    setStyle(reloadStyles());
  };

  const handleMonEspace = () => {
    navigate('MonEspace');
  };
  useEffect(() => {
    const subscription = Dimensions.addEventListener('change', updateStyles);
    return () => {
      subscription.remove();
    };
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleMove = ({item}: {item: any}) => {
    if (!isHome && !checkSignedUser(user).connected) {
      setShowModal(true);
      switch (item.title) {
        case 'Demander un devis':
          setScreenFocus('DemanderDevis');
          break;
        case 'Souscrire un contrat':
          setScreenFocus('SouscrireContrat');
          break;
        case 'Mes contrats':
          setScreenFocus('MesContrats');
          break;
        case 'Mes sinistres':
          setScreenFocus('MesSinistres');
          break;
        case 'Paiement':
          setScreenFocus('PayementList');
          break;
        case 'Notifications':
          setScreenFocus('Notification');
          break;
        case 'Mon Profil':
          setScreenFocus('MonProfil');
          break;
        default:
          break;
      }
    } else {
      if (item.title === 'Lexique') {
        navigate('Lexique');
      } else if (item.title === 'FAQ') {
        navigate('FAQ');
      } else if (item.title === 'Souscrire un contrat') {
        navigate('SouscrireContrat', {dateNaissance: '', montant: ''});
      } else if (item.title === 'Mes contrats') {
        navigate('MesContrats');
      } else if (item.title === 'Mes sinistres') {
        navigate('MesSinistres');
      } else if (item.title === 'Notifications') {
        navigate('Notification');
      } else if (item.title === 'Mon Profil') {
        navigate('MonProfil');
      } else if (item.title === 'Mes sinistres') {
        navigate('Home');
      } else if (item.title === 'Paiement') {
        navigate('PayementList');
      } else if (item.title === 'Nous contacter') {
        navigate('DemandeRdv');
      } else if (item.title === 'Demander simulation') {
        navigate('DemanderSimulation');
      } else if (item.title === 'Demander un devis') {
        navigate('DemanderDevis');
      } else if (item.title === 'Auto Moto') {
        navigate('AutoMotoSinistre');
      } else if (item.title === 'Famille') {
        navigate('FamilleSinistre', {
          primaryTitle: 'FAMILLE',
          secondTitle: 'famille',
        });
      } else if (item.title === 'Habitation') {
        navigate('HabitationSinistre', {
          primaryTitle: 'HABITATION',
          secondTitle: 'habitation',
        });
      } else if (item.title === 'Accident et voyage') {
        navigate('AccidentVoyageSinistre');
      } else {
        navigate('Produit', {data: item.title});
      }
    }
  };

  useEffect(() => {
    if (userConnected.current) {
      ImageServices()
        .getUtilisateurImage(infos.imageUrl)
        .then(res => setProfilePicture(res))
        .catch(err => console.log(err));
    }
  }, [userConnected.current]);

  return (
    <View style={[globalStyle.containerFluid, {width: '100%', padding: 8}]}>
      <div style={{position: 'relative', zIndex: 9999999999}}>
        {!isHome && ShowModal && (
          <ConfirmationModal
            title={ConnexionTitle}
            content={''}
            btn1="Connexion"
            btn2="Annuler"
            handleBtn1={save}
            handleBtn2={cancel}
          />
        )}
      </div>

      <View style={[stylesState.row, {paddingBottom: 20, flex: 0}]}>
        {itemState.map((item, index) => (
          <TouchableOpacity
            style={stylesState.containerMenuItem}
            key={index}
            onPress={() => {
              handleMove({item});
            }}>
            <Image
              style={stylesState.MenuItemLogo as ImageStyle}
              source={item.source}
            />
            {item.title === 'Notifications' &&
            numberNotification &&
            numberNotification > 0 ? (
              <Text style={stylesState.MenuItemFont}>
                {item.title} (
                {numberNotification &&
                  numberNotification > 0 &&
                  numberNotification}
                )
              </Text>
            ) : (
              <Text style={stylesState.MenuItemFont}>{item.title}</Text>
            )}
          </TouchableOpacity>
        ))}
        {isHome ? (
          <TouchableOpacity
            style={[stylesState.containerMenuItemFullHome]}
            onPress={() => {
              handleMonEspace();
            }}>
            <div style={styleGradient}>
              <View style={stylesState.MenuIteAvatarContain}>
                <Image
                  source={
                    !userConnected.current || profilePicture == ''
                      ? // eslint-disable-next-line @typescript-eslint/no-require-imports
                        require('../../../ressources/images/user_ph.png')
                      : {
                          uri: profilePicture,
                        }
                  }
                  style={stylesState.MenuItemLogoFull as ImageStyle}
                />
              </View>
              <View style={stylesState.profilText}>
                <Text style={stylesState.titleSecondaryH2}>Mon espace</Text>
                <Text style={stylesState.textDescription}>
                  {infos.description}
                </Text>
                <TouchableOpacity
                  onPress={() => {
                    handleLogin();
                  }}>
                  <Text style={globalStyle.linkProfilWeb}>
                    {infos.connexion}
                  </Text>
                </TouchableOpacity>
              </View>
            </div>
          </TouchableOpacity>
        ) : null}
      </View>
    </View>
  );
}

export const MenuItem = connect(mapStateToProps, mapDispatchToProps)(FMenuItem);
